import React, { useState } from "react";
import { Warning, X } from "@phosphor-icons/react";

export default function DisclaimerBanner() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div
      className="w-full border-b border-amber-200 bg-amber-50/80 text-amber-900 text-xs sm:text-sm"
      data-testid="disclaimer-banner"
    >
      <div className="max-w-[1400px] mx-auto px-6 py-2.5 flex items-center gap-3">
        <Warning weight="regular" className="w-4 h-4 shrink-0" />
        <p className="leading-snug">
          <span className="font-semibold">Not legal advice.</span> This tool generates draft documents for review before filing. Use at your own risk.
        </p>
        <button
          onClick={() => setOpen(false)}
          className="ml-auto p-1 hover:bg-amber-100 rounded-sm"
          aria-label="Dismiss disclaimer"
          data-testid="dismiss-disclaimer-btn"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
